/* Monkey Transfers — Global JS */

/* Fade-up scroll animation */
(function(){
  const obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('visible')});
  },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.fade-up').forEach(function(el){obs.observe(el)});
})();

/* Navbar scroll shadow */
(function(){
  const nav=document.querySelector('.header-wrapper');
  if(!nav)return;
  window.addEventListener('scroll',function(){
    nav.style.boxShadow=window.scrollY>60?'0 4px 24px rgba(0,0,0,0.1)':'0 2px 12px rgba(0,0,0,0.06)';
  });
})();

/* Sticky header on scroll */
(function(){
  var header=document.querySelector('.header-wrapper');
  if(!header)return;
  window.addEventListener('scroll',function(){
    if(window.scrollY>=100)header.classList.add('fixed');
    else header.classList.remove('fixed');
  },{passive:true});
})();

/* FAQ accordion */
function toggleFAQ(btn){
  var item=btn.closest('.faq-item');
  var isOpen=item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function(el){
    el.classList.remove('open');
    el.querySelector('.faq-question').setAttribute('aria-expanded','false');
  });
  if(!isOpen){
    item.classList.add('open');
    btn.setAttribute('aria-expanded','true');
  }
}